/**
 * @Description: 打印机类别的信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  PrinterCategoryModel,
  PrinterCategorySearchModel,
  PrinterCategoryPageSearchModel,
  PrinterCategoryAddModel,
  PrinterCategoryUpdateModel,
  IdsModel
} from '@/model/product/PrinterCategoryModel'

const baseUrl = Route.product + '/printerCategory'

/**
 * 搜索分页数据
 */
export const pageSearchPrinterCategory = (param: PrinterCategoryPageSearchModel) => {
  return https().request<RootObject<PageRespModel<PrinterCategoryModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchPrinterCategory = (param: PrinterCategorySearchModel) => {
  return https().request<RootObject<PrinterCategoryModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getPrinterCategory = (id: number) => {
  return https().request<RootObject<PrinterCategoryModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addPrinterCategory = (param: PrinterCategoryAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updatePrinterCategory = (param: PrinterCategoryUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removePrinterCategory = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemovePrinterCategory = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
